<template>
  <div v-if="$companyConfiguration.knowledgeBase.isEnabled()">

    <page-heading heading="Как это работает?">
      <div slot="right">
        <el-button
          v-if="$canAndRulesPass(user, $permissions.KNOWLEDGE_BASE.MANAGE)"
          type="primary"
          size="small"
          icon="fas fa-plus"
          @click="openEditDialog()"
        >
          Добавить ссылку
        </el-button>
      </div>
    </page-heading>

    <el-card>
      <el-table v-loading="loading" :data="links" empty-text="Нет данных">
        <el-table-column prop="name" label="Название">
          <template v-slot="scope">
            <a
              :href="scope.row.url"
              target="_blank"
              rel="noopener noreferrer"
              class="knowledge-base-link-name"
            >
              {{ scope.row.name }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          v-if="$canAndRulesPass(user, $permissions.KNOWLEDGE_BASE.MANAGE)"
          width="100"
          align="right"
        >
          <template v-slot="scope">
            <el-button
              class="table-action-button"
              size="mini"
              round
              icon="fas fa-pen"
              @click="openEditDialog(scope.row)"
            >
            </el-button>
            <el-button
              class="table-action-button"
              size="mini"
              round
              icon="far fa-trash-alt"
              @click="confirmDeleteLink(scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <knowledge-base-link-edit-dialog
      ref="editDialog"
      @link-saved="loadLinks"
    ></knowledge-base-link-edit-dialog>

  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import KnowledgeBaseLinkEditDialog from "@/components/knowledgeBase/KnowledgeBaseLinkEditDialog.vue";
import {mapGetters} from "vuex";

export default {
  name: 'KnowledgeBase',
  components: {KnowledgeBaseLinkEditDialog, PageHeading},

  computed: {
    ...mapGetters(['user']),
  },

  data() {
    return {
      loading: false,
      links: [],
    }
  },

  mounted() {
    this.loadLinks();
  },

  methods: {
    loadLinks() {
      this.loading = true;
      this.$api.knowledgeBase.search({'per-page': 500})
        .then(({data}) => {
          this.links = data.links;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    openEditDialog(link = {}) {
      this.$refs.editDialog.open(link);
    },

    confirmDeleteLink(link) {
      this.$confirm('Ссылка будет удалена без возможности восстановления', 'Удаление ссылки', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'warning',
      })
        .then(() => this.deleteLink(link))
    },

    deleteLink(link) {
      this.$api.knowledgeBase.delete({id: link.id})
        .then(() => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Ссылка успешно удалена'
          });
        })
        .finally(() => {
          this.loadLinks();
        })
    },
  }
}
</script>

<style scoped>
.knowledge-base-link-name {
  text-decoration: underline;
  color: inherit;
}
</style>
